<template>
  <div v-if="updateSign"></div>
  <div class="header">
    <!-- 折叠按钮 -->
    <div class="collapse-btn" @click="collapseChage">
      <el-icon v-if="!collapse"><Fold /></el-icon>
      <el-icon v-else><Expand /></el-icon>
    </div>
    <div class="logo">
      <span class="logo-title">{{ title }}</span>
      <span class="logo-tips">{{ localData.platform_name }}</span>
    </div>

    <!-- 应用切换标签 -->
    <div class="app-tabs">
      <div v-for="(item, index) in AppList" :key="index" class="app-tab-item" :class="{ 'is-active': title === item.name }" @click="goApp(item)">
        <span>{{ item.name }}</span>
      </div>
    </div>

    <div class="header-right">
      <div class="header-user-con">
        <el-dropdown>
          <span class="el-dropdown-link user-avator">
            {{ localData.user_name ? localData.user_name : localData.name }}
            <el-icon size="18" style="transform: translateY(20%)"><ArrowDown /></el-icon>
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <div>
                <el-dropdown-item @click="changePwd">修改密码</el-dropdown-item>
                <el-dropdown-item @click="handleCommand">退出</el-dropdown-item>
              </div>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>
<script>
import { Expand, Fold, ArrowDown } from '@element-plus/icons';
export default {
  components: {
    Expand,
    Fold,
    ArrowDown,
  },
  data() {
    return {
      fullscreen: false,
      message: 2,
      localData: '',
      appid: '',
      title: '',
      AppList: [],
      screenWidth: document.body.clientWidth, //获取页面宽度
    };
  },
  computed: {
    collapse() {
      return this.$store.state.collapse;
    },

    updateSign() {
      this.appidAssign();
      return this.$store.state.updateSign;
    },
  },
  watch: {
    screenWidth(newValue) {
      if (Number(newValue) < 1024) {
        this.$store.commit('hadndleCollapse', true);
      } else {
        this.$store.commit('hadndleCollapse', false);
      }
    },
  },
  methods: {
    // 点击前往应用
    goApp(e) {
      localStorage.setItem('app', JSON.stringify(e));
      this.$store.commit('handleUpdateSign', false);
      this.$router.push('/index');
    },
    //修改账号资料
    changePwd() {
      this.$router.push({
        path: '/cloud/sys/changePwd',
        query: {},
      });
    },

    // 动态赋值标题
    appidAssign() {
      this.title = localStorage.getItem('app') ? JSON.parse(localStorage.getItem('app')).name : '';
    },

    // 获取我的应用
    myAppList() {
      this.$cloudApi.myAppList().then(res => {
        this.AppList = res.data;
        if (this.title == '') {
          this.title = res.data[0].name;
        }
      });
    },

    // 切换到云平台
    handleSwitch() {
      localStorage.removeItem('app');
      this.$store.commit('handleUpdateSign', false);
      this.$router.push('/index');
    },

    // 退出
    handleCommand() {
      this.$cloudApi.logOut().then(() => {
        localStorage.removeItem('userInfo');
        localStorage.removeItem('limits');
        localStorage.removeItem('app');
        this.$store.getters.cleanRouter;
        this.$store.commit('handleUpdateSign', false);
        location.reload();
        // this.$router.push("/login");
      });
    },

    // 侧边栏折叠
    collapseChage() {
      this.$store.commit('hadndleCollapse', !this.collapse);
    },
  },
  mounted() {
    this.myAppList();
    this.$store.commit('hadndleCollapse', this.collapse);

    // 监听页面宽度变化
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        this.screenWidth = window.screenWidth;
      })();
    };

    this.localData = JSON.parse(localStorage.getItem('userInfo'));
  },
};
</script>

<style scoped lang="scss">
.header {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 60px;
  font-size: 22px;
  color: #fff;
  display: flex;
  align-items: center;
}
.collapse-btn {
  padding: 0 21px;
  cursor: pointer;
  line-height: 60px;
  font-size: 18px;
  flex-shrink: 0;
}
.header .logo {
  width: 250px;
  line-height: 60px;
  flex-shrink: 0;
  .logo-title {
    margin-right: 8px;
    font-size: 20px;
  }
  .logo-tips {
    font-size: 14px;
  }
}

// 应用切换标签
.app-tabs {
  display: flex;
  align-items: center;
  //gap: 8px;
  margin-left: 0px;
  flex: 1;

  .app-tab-item {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100px;
    height: 57px;
    background: rgba(255, 255, 255, 0.1);
    //border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 4px;
    color: rgba(255, 255, 255, 0.85);
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s;
    text-align: center;

    span {
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 100%;
      padding: 0 8px;
    }

    &:hover {
      background: rgba(255, 255, 255, 0.15);
      border-color: rgba(255, 255, 255, 0.3);
      color: #fff;
    }

    &.is-active {
      background: rgba(64, 158, 255, 0.2);
      border-color: #409eff;
      color: #fff;
      font-weight: 500;

      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 2px;
        background: #409eff;
      }
    }
  }
}

.header-right {
  padding-right: 30px;
  flex-shrink: 0;
}
.header-user-con {
  display: flex;
  height: 60px;
  align-items: center;
}
.btn-fullscreen {
  transform: rotate(45deg);
  margin-right: 5px;
  font-size: 24px;
}
.btn-bell,
.btn-fullscreen {
  position: relative;
  width: 30px;
  height: 30px;
  text-align: center;
  border-radius: 15px;
  cursor: pointer;
}
.btn-bell-badge {
  position: absolute;
  right: 0;
  top: -2px;
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background: #f56c6c;
  color: #fff;
}
.btn-bell .el-icon-bell {
  color: #fff;
}
.user-name {
  margin-left: 10px;
}
.user-avator {
  margin-left: 20px;
  font-size: 14px;
  cursor: pointer;
}
.user-avator img {
  display: block;
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.el-dropdown-link {
  color: #fff;
  cursor: pointer;
}
.el-dropdown-menu__item {
  text-align: center;
}
</style>
